/**
 * Общее для азартных мини-игр (interactives.md, раздел E).
 *
 * Ставка никогда не больше денег жизни и никогда не отрицательна;
 * «пропустить» и автопилот для всего раздела E — «не играть»:
 * деньги 0, тяга 0 (Review Focus 2 плана 2b).
 */
import type { Dataset, GamblingLaw } from '@life/data';
import { getValue } from '@life/data';
import type { Life, MinigameOutcome } from '@life/engine';
import type { ExpectancyText } from '../types';

export const CASINO_MIN_AGE = 18;

/** Ставка в пределах [0, money]; NaN и отрицательное — ноль. */
export function clampBet(bet: number, money: number): number {
  if (!(bet > 0) || !Number.isFinite(bet)) return 0;
  const cash = Number.isFinite(money) && money > 0 ? money : 0;
  return Math.min(bet, cash);
}

/** Исход «не играть». */
export function noPlay(): MinigameOutcome {
  return { moneyDelta: 0, urgeDelta: 0 };
}

/** Казино (рулетка, слоты, блэкджек): с 18 лет, только legal, только в городе. */
export function casinoAvailable(life: Life, law: GamblingLaw): boolean {
  return life.age >= CASINO_MIN_AGE && law === 'legal' && life.urban;
}

/** Процент потерь по доле возврата, один знак после запятой. */
export function lossPercent(rtp: number): number {
  return Math.round((1 - rtp) * 1000) / 10;
}

export function expectancy(id: string, rtp: number): ExpectancyText {
  return { key: `minigame.expect.${id}`, params: { loss: lossPercent(rtp) } };
}

/** ВВП на душу (ППС) страны жизни в текущем году. */
export function gdpPpp(ds: Dataset, life: Life): number {
  return getValue(ds, life.iso3, 'gdpPpp', life.birthYear + life.age).v;
}

/** Годовой доход жизни: доход работы, без работы — ВВП на душу как прокси. */
export function yearlyIncome(ds: Dataset, life: Life): number {
  return life.job ? life.job.income : gdpPpp(ds, life);
}
